import { StorageType, useBrowserStorage } from '@/hooks/useBrowserStorage';

export const useLocalStorage = <T>(key: string, initialValue: T) => {
  return useBrowserStorage<T>(key, initialValue, StorageType.Local);
};
